import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Paper,
  Button,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Grid,
  Card,
  CardContent,
  Chip,
  Stack
} from '@mui/material';
import {
  Groups as GroupsIcon,
  Diamond as DiamondIcon,
  Home as HomeIcon,
  MonetizationOn as MonetizationOnIcon,
  AddPhotoAlternate as AddPhotoAlternateIcon,
  ArrowForward as ArrowForwardIcon,
  Share as ShareIcon,
  CardGiftcard as CardGiftcardIcon,
  PhotoCamera as PhotoCameraIcon,
  VerifiedUser as VerifiedUserIcon,
  TrendingUp as TrendingUpIcon,
  Stars as StarsIcon,
  Rocket as RocketIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router';
import Header from '../Header';
import Footer from '../Footer';
import ReactGA from "react-ga4";
import SettingPopup from '../SettingPopup';

const MonetizationLP = () => {
  const navigate = useNavigate()
  const [showSetting,setShowSetting] = useState(false)
  const creatorBenefits = [
    {
      icon: <HomeIcon color="primary" />,
      primary: "トップページで作品が紹介されます。"
    },
    {
      icon: <MonetizationOnIcon color="primary" />,
      primary: "作品の投稿の評価に応じて活動支援金をお支払いします。",
      secondary: "収益化には別途、課金プラン加入(スタンダードまたはプレミアム、プレミアムプラス)が必要です。"
    },
    {
      icon: <AddPhotoAlternateIcon color="primary" />,
      primary: "投稿枚数無制限"
    }
  ];
  useEffect(() => {
    ReactGA.initialize("G-7W9JKQ50Y6");
    ReactGA.send({
      hitType: "pageview",
      // アクセスしたパス (pathname) とクエリ文字列 (search) を送付する (必要に応じて編集する)
      page: "/monetizationLP",
    })

    // タイトル設定
    document.querySelector("title").textContent = "収益化について | アワートAI - AI活用プラットフォーム"
  },[])

  return (
    <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', minHeight: '100vh' }}>
        <Header />
        {showSetting ? (<SettingPopup switch={setShowSetting} activeKey="monetization" />) : ""}
        <Container maxWidth="lg" sx={{ py: 8 }}>
        {/* Hero Header */}
        <Box textAlign="center" sx={{ mb: 8 }}>
            <Typography 
                variant="h1" 
                component="h1" 
                sx={{ 
                    fontSize: { xs: '2.5rem', md: '4rem' },
                    fontWeight: 'bold',
                    background: 'linear-gradient(45deg, #fff, #f0f8ff)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    color: 'transparent',
                    mb: 2
                }}
            >
                💰 収益化システム
            </Typography>
            <Typography 
                variant="h5" 
                sx={{ 
                    color: 'rgba(255,255,255,0.9)',
                    mb: 4,
                    maxWidth: '600px',
                    mx: 'auto'
                }}
            >
                アワートAIで創作活動を収益に変える3つの方法
            </Typography>
            <Chip 
                label="🚀 今すぐ始めよう" 
                color="secondary" 
                size="large"
                sx={{ fontSize: '1.1rem', py: 2, px: 3 }}
            />
        </Box>

        {/* Features Grid */}
        <Grid container spacing={4} sx={{ mb: 6 }}>
            {/* Membership Section */}
            <Grid item xs={12} md={4}>
                <Card 
                    elevation={8} 
                    sx={{ 
                        height: '100%',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        borderRadius: 3,
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                            transform: 'translateY(-8px)',
                            boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
                        }
                    }}
                >
                    <CardContent sx={{ p: 4, textAlign: 'center' }}>
                        <GroupsIcon sx={{ fontSize: 60, mb: 2, color: '#ffd700' }} />
                        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                            メンバーシップ
                        </Typography>
                        <Typography sx={{ mb: 3, opacity: 0.9 }}>
                            プランを作成して月次・単品販売で収益化。すぐに始められます。
                        </Typography>
                        <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 3 }}>
                            <Chip label="即開始可能" size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
                            <Chip label="月次販売" size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
                        </Stack>
                        <Button 
                            variant="contained" 
                            fullWidth
                            size="large"
                            sx={{ 
                                bgcolor: '#ffd700',
                                color: '#333',
                                fontWeight: 'bold',
                                '&:hover': { bgcolor: '#ffed4e' }
                            }}
                            onClick={() => navigate("/manage/payouts")}
                        >
                            設定を開始
                        </Button>
                    </CardContent>
                </Card>
            </Grid>

            {/* Creator Support Program */}
            <Grid item xs={12} md={4}>
                <Card 
                    elevation={8} 
                    sx={{ 
                        height: '100%',
                        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                        color: 'white',
                        borderRadius: 3,
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                            transform: 'translateY(-8px)',
                            boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
                        }
                    }}
                >
                    <CardContent sx={{ p: 4, textAlign: 'center' }}>
                        <DiamondIcon sx={{ fontSize: 60, mb: 2, color: '#ffd700' }} />
                        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                            公認クリエイター
                        </Typography>
                        <Typography sx={{ mb: 3, opacity: 0.9 }}>
                            トップページ掲載、活動支援金、投稿無制限の特典を獲得。
                        </Typography>
                        <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 3 }}>
                            <Chip label="特別待遇" size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
                            <Chip label="支援金" size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
                        </Stack>
                        <Button 
                            variant="contained" 
                            fullWidth
                            size="large"
                            sx={{ 
                                bgcolor: '#ffd700',
                                color: '#333',
                                fontWeight: 'bold',
                                '&:hover': { bgcolor: '#ffed4e' }
                            }}
                            onClick={() => {
                              setShowSetting(true)
                            }}
                        >
                            詳細を確認
                        </Button>
                    </CardContent>
                </Card>
            </Grid>

            {/* Affiliate System */}
            <Grid item xs={12} md={4}>
                <Card 
                    elevation={8} 
                    sx={{ 
                        height: '100%',
                        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                        color: 'white',
                        borderRadius: 3,
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                            transform: 'translateY(-8px)',
                            boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
                        }
                    }}
                >
                    <CardContent sx={{ p: 4, textAlign: 'center' }}>
                        <ShareIcon sx={{ fontSize: 60, mb: 2, color: '#ffd700' }} />
                        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                            アフィリエイト
                        </Typography>
                        <Typography sx={{ mb: 3, opacity: 0.9 }}>
                            友達紹介で継続収益。最大30%の高額報酬を獲得可能。
                        </Typography>
                        <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 3 }}>
                            <Chip label="継続収益" size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
                            <Chip label="高額報酬" size="small" sx={{ bgcolor: 'rgba(255,255,255,0.2)' }} />
                        </Stack>
                        <Button 
                            variant="contained" 
                            fullWidth
                            size="large"
                            sx={{ 
                                bgcolor: '#ffd700',
                                color: '#333',
                                fontWeight: 'bold',
                                '&:hover': { bgcolor: '#ffed4e' }
                            }}
                            onClick={() => navigate("/affiliate/dashboard")}
                        >
                            今すぐ開始
                        </Button>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>

        {/* Detailed Affiliate System Section */}
        <Paper 
            elevation={12} 
            sx={{ 
                p: 6, 
                mt: 6,
                background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(240,248,255,0.95) 100%)',
                borderRadius: 4,
                backdropFilter: 'blur(10px)'
            }}
        >
            <Box textAlign="center" sx={{ mb: 6 }}>
                <Box sx={{ mb: 3 }}>
                    <RocketIcon sx={{ fontSize: 80, color: '#4facfe', mb: 2 }} />
                </Box>
                <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
                    🎯 アフィリエイト
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '800px', mx: 'auto' }}>
                    業界最高水準の報酬率で、あなたの紹介活動を最大限に収益化
                </Typography>
            </Box>

            {/* 3-Step Reward System */}
            <Box sx={{ mb: 6 }}>
                <Typography variant="h4" textAlign="center" sx={{ mb: 4, fontWeight: 'bold', color: '#4facfe' }}>
                    ⭐ 3段階報酬システム
                </Typography>
                
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                        <Card 
                            elevation={6}
                            sx={{ 
                                p: 3, 
                                textAlign: 'center',
                                background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
                                color: '#2d3748',
                                borderRadius: 3,
                                height: '100%'
                            }}
                        >
                            <VerifiedUserIcon sx={{ fontSize: 50, mb: 2, color: '#2d3748' }} />
                            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                                STEP 1
                            </Typography>
                            <Typography variant="h6" sx={{ mb: 2, color: '#2d3748', fontWeight: 600 }}>
                                登録特典
                            </Typography>
                            <Box sx={{ bgcolor: '#ffffff', p: 2, borderRadius: 2, mb: 2, border: '2px solid #e53e3e' }}>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#c53030' }}>
                                    2,000pt
                                </Typography>
                            </Box>
                            <Typography variant="body2" sx={{ color: '#4a5568', fontWeight: 500 }}>
                                SMS認証完了で両者に即時付与
                            </Typography>
                        </Card>
                    </Grid>
                    
                    <Grid item xs={12} md={4}>
                        <Card 
                            elevation={6}
                            sx={{ 
                                p: 3, 
                                textAlign: 'center',
                                background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
                                color: '#2d3748',
                                borderRadius: 3,
                                height: '100%'
                            }}
                        >
                            <PhotoCameraIcon sx={{ fontSize: 50, mb: 2, color: '#2d3748' }} />
                            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                                STEP 2
                            </Typography>
                            <Typography variant="h6" sx={{ mb: 2, color: '#2d3748', fontWeight: 600 }}>
                                活動特典
                            </Typography>
                            <Box sx={{ bgcolor: '#ffffff', p: 2, borderRadius: 2, mb: 2, border: '2px solid #38a169' }}>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2f855a' }}>
                                    3,000pt
                                </Typography>
                            </Box>
                            <Typography variant="body2" sx={{ color: '#4a5568', fontWeight: 500 }}>
                                10作品投稿達成で両者に付与
                            </Typography>
                        </Card>
                    </Grid>
                    
                    <Grid item xs={12} md={4}>
                        <Card 
                            elevation={6}
                            sx={{ 
                                p: 3, 
                                textAlign: 'center',
                                background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
                                color: '#2d3748',
                                borderRadius: 3,
                                height: '100%'
                            }}
                        >
                            <TrendingUpIcon sx={{ fontSize: 50, mb: 2, color: '#2d3748' }} />
                            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                                STEP 3
                            </Typography>
                            <Typography variant="h6" sx={{ mb: 2, color: '#2d3748', fontWeight: 600 }}>
                                継続収益
                            </Typography>
                            <Box sx={{ bgcolor: '#ffffff', p: 2, borderRadius: 2, mb: 2, border: '2px solid #4facfe' }}>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c5282' }}>
                                    最大30%
                                </Typography>
                            </Box>
                            <Typography variant="body2" sx={{ color: '#4a5568', fontWeight: 500 }}>
                                プラン料金から毎月継続報酬
                            </Typography>
                        </Card>
                    </Grid>
                </Grid>
            </Box>

            {/* Revenue Details */}
            <Box sx={{ 
                bgcolor: '#ffffff', 
                p: 4, 
                borderRadius: 3,
                border: '2px solid #4facfe',
                mb: 6,
                boxShadow: '0 8px 32px rgba(79, 172, 254, 0.2)'
            }}>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#2c5282', textAlign: 'center', mb: 4 }}>
                    💰 継続収益の詳細
                </Typography>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ 
                            textAlign: 'center', 
                            p: 3,
                            bgcolor: '#fff5f5',
                            borderRadius: 2,
                            border: '2px solid #e53e3e',
                            boxShadow: '0 4px 12px rgba(229, 62, 62, 0.15)'
                        }}>
                            <Typography variant="h2" sx={{ fontWeight: 'bold', color: '#c53030', mb: 1 }}>
                                30%
                            </Typography>
                            <Typography variant="h6" sx={{ color: '#1a202c', fontWeight: 'bold' }}>
                                初回月報酬率
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#4a5568', mt: 1, fontWeight: 500 }}>
                                被紹介者がプラン加入した初月
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ 
                            textAlign: 'center', 
                            p: 3,
                            bgcolor: '#f0fff4',
                            borderRadius: 2,
                            border: '2px solid #38a169',
                            boxShadow: '0 4px 12px rgba(56, 161, 105, 0.15)'
                        }}>
                            <Typography variant="h2" sx={{ fontWeight: 'bold', color: '#2f855a', mb: 1 }}>
                                10%
                            </Typography>
                            <Typography variant="h6" sx={{ color: '#1a202c', fontWeight: 'bold' }}>
                                継続月報酬率
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#4a5568', mt: 1, fontWeight: 500 }}>
                                2ヶ月目以降（最大12ヶ月）
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                {/* Revenue Calculation Example */}
                <Box sx={{ mt: 4, p: 3, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#2d3748', textAlign: 'center', mb: 3 }}>
                        📊 12ヶ月継続時の収益例（プレミアムプラン ¥4,000/月の場合）
                    </Typography>
                    
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#fff5f5', borderRadius: 1, border: '1px solid #fed7d7' }}>
                                <Typography variant="body2" sx={{ color: '#c53030', fontWeight: 'bold', mb: 1 }}>
                                    1ヶ月目
                                </Typography>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                                    ¥1,200
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#4a5568' }}>
                                    (¥4,000 × 30%)
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#f0fff4', borderRadius: 1, border: '1px solid #c6f6d5' }}>
                                <Typography variant="body2" sx={{ color: '#2f855a', fontWeight: 'bold', mb: 1 }}>
                                    2-12ヶ月目
                                </Typography>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                                    ¥400/月
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#4a5568' }}>
                                    (¥4,000 × 10%) × 11ヶ月
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#ebf8ff', borderRadius: 1, border: '1px solid #90cdf4' }}>
                                <Typography variant="body2" sx={{ color: '#2b6cb0', fontWeight: 'bold', mb: 1 }}>
                                    合計収益
                                </Typography>
                                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                                    ¥5,600
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#4a5568' }}>
                                    1人紹介あたり12ヶ月間
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box sx={{ mt: 3, p: 2, bgcolor: '#fffbeb', borderRadius: 1, border: '1px solid #fbbf24' }}>
                        <Typography variant="body2" sx={{ color: '#92400e', textAlign: 'center', fontWeight: 500 }}>
                            💡 10人紹介して全員が12ヶ月継続した場合：<strong>¥56,000の収益</strong>
                        </Typography>
                    </Box>

                    {/* Activity-based bonus note */}
                    <Box sx={{ mt: 3, p: 3, bgcolor: '#f0f9ff', borderRadius: 2, border: '2px solid #0ea5e9' }}>
                        <Typography variant="body2" sx={{ color: '#0369a1', textAlign: 'center', fontWeight: 600, mb: 1 }}>
                            📈 <strong>アクティビティボーナス</strong>
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#075985', textAlign: 'center', fontWeight: 500 }}>
                            継続的な紹介活動や被紹介者の活動状況によって、<br/>
                            報酬率が<strong>さらにアップ</strong>する場合があります
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* How to Start */}
            <Box sx={{ 
                bgcolor: '#ffffff', 
                p: 4, 
                borderRadius: 3,
                border: '2px solid #e2e8f0',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
            }}>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center', mb: 4, color: '#2d3748' }}>
                    🚀 今すぐ始める方法
                </Typography>
                
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ textAlign: 'center', p: 3, bgcolor: '#ebf8ff', borderRadius: 2, border: '1px solid #90cdf4' }}>
                            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#2b6cb0' }}>
                                👤 招待する側
                            </Typography>
                            <Typography sx={{ color: '#2d3748', fontWeight: 500 }}>
                                SMS認証・本人確認を完了するだけで、すぐに招待リンクが利用可能になります
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ textAlign: 'center', p: 3, bgcolor: '#fed7d7', borderRadius: 2, border: '1px solid #fc8181' }}>
                            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#c53030' }}>
                                👥 招待される側
                            </Typography>
                            <Typography sx={{ color: '#2d3748', fontWeight: 500 }}>
                                アフィリエイトリンク経由での登録で、自動的に特典対象となります
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{ mt: 4, p: 3, bgcolor: '#f7fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#2d3748' }}>
                        🔗 招待リンク例
                    </Typography>
                    <Box sx={{ 
                        bgcolor: '#1a202c', 
                        color: '#48bb78', 
                        p: 2, 
                        borderRadius: 1, 
                        fontFamily: 'monospace',
                        fontSize: '0.9rem',
                        overflow: 'auto',
                        border: '1px solid #4a5568'
                    }}>
                        https://ourt-ai.work/image/xxxxxxxxxxxxxxxx?af=ourt_ai
                    </Box>
                </Box>
            </Box>

            {/* CTA Button */}
            <Box sx={{ textAlign: 'center', mt: 6 }}>
                <Button 
                    variant="contained" 
                    size="large"
                    endIcon={<RocketIcon />}
                    onClick={() => navigate("/affiliate/dashboard")}
                    sx={{ 
                        px: 6, 
                        py: 2, 
                        fontSize: '1.3rem',
                        fontWeight: 'bold',
                        background: 'linear-gradient(45deg, #4facfe 30%, #00f2fe 90%)',
                        backgroundSize: '200% 200%',
                        boxShadow: '0 10px 30px rgba(79, 172, 254, 0.4)',
                        borderRadius: 3,
                        textTransform: 'none',
                        position: 'relative',
                        overflow: 'hidden',
                        transition: 'all 0.3s ease',
                        animation: 'gradientMove 3s ease-in-out infinite, pulse 2s ease-in-out infinite',
                        '&:before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: '-100%',
                            width: '100%',
                            height: '100%',
                            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                            animation: 'shimmer 2.5s infinite'
                        },
                        '&:after': {
                            content: '""',
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            width: '0%',
                            height: '3px',
                            background: 'linear-gradient(90deg, #ffffff, #e0f2fe, #ffffff)',
                            transition: 'width 0.4s ease-out',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.8)'
                        },
                        '&:hover': {
                            background: 'linear-gradient(45deg, #00f2fe 30%, #4facfe 90%)',
                            transform: 'translateY(-3px)',
                            boxShadow: '0 20px 40px rgba(79, 172, 254, 0.8)',
                            animation: 'gradientMove 1s ease-in-out infinite'
                        },
                        '&:hover:after': {
                            width: '100%'
                        },
                        '@keyframes gradientMove': {
                            '0%': { backgroundPosition: '0% 50%' },
                            '50%': { backgroundPosition: '100% 50%' },
                            '100%': { backgroundPosition: '0% 50%' }
                        },
                        '@keyframes pulse': {
                            '0%': { boxShadow: '0 10px 30px rgba(79, 172, 254, 0.4)' },
                            '50%': { boxShadow: '0 15px 35px rgba(79, 172, 254, 0.7)' },
                            '100%': { boxShadow: '0 10px 30px rgba(79, 172, 254, 0.4)' }
                        },
                        '@keyframes shimmer': {
                            '0%': { left: '-100%' },
                            '100%': { left: '100%' }
                        }
                    }}
                >
                    アフィリエイトを今すぐ開始
                </Button>
            </Box>
        </Paper>
        </Container>
        <Footer />
    </div>
  );
};

export default MonetizationLP;